const BASE_URL = 'ai-service/api/utility-infrastructure'

const utilityInfrastructureRequests = {
  runUtilityInfrastructureAnalysisRequest: (data) => {
    return {
      url: `${BASE_URL}/run-analysis`,
      method: 'post',
      data,
    }
  },
  getPolesUniqueAiObjectsRequest: (contentId) => {
    return {
      url: `${BASE_URL}/${contentId}/poles`,
      method: 'get',
    }
  },
}

export default utilityInfrastructureRequests
